import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { VStack } from '@/components/Layout';

import { useInHousePackage } from './-hooks/useInHousePackage';
import { listInHousePackages } from './-query/api';
import { SearchSchema } from './-zod-schemas';

/**
 * テナント専用パッケージの個別表示。
 * 種別ごとに表示を切り替える（セルフレポート＝グルーピング表示 / 申請＝既存パッケージ表示型）。
 */
export const Route = createFileRoute(
  '/_staff/it-operation-core/_root/in-house-packages/$packageId',
)({
  loader: () => listInHousePackages(),
  validateSearch: zodValidator(SearchSchema),
  component: RouteComponent,
});

function RouteComponent() {
  const { packageId } = Route.useParams();
  const packages = Route.useLoaderData();

  const operationPackage = packages.find((pkg) => pkg.id === packageId);

  if (!operationPackage) {
    throw new Error(`In-house package not found for ID: ${packageId}`);
  }

  const { Component } = useInHousePackage({
    packageType: operationPackage.type,
  });

  return (
    <VStack className="h-full w-full">
      <Component operationPackage={operationPackage} />
    </VStack>
  );
}
